import classNames from 'classnames';

export const MOBILE_BREAKPOINT = 384;

/*
Uses @sm container query breakpoint (384px).
Shows desktop layout when container >= 384px.
Note: container query variants (e.g. @sm) only apply when an ancestor has className="sui-@container".
*/

export const showDesktopLayout = classNames(
  'sui-hidden',
  '@sm:sui-block'
);

export const showMobileLayout = classNames(
  'sui-block',
  '@sm:sui-hidden'
);

export const showDesktopLayoutIf = (condition) => classNames('sui-hidden',
  { '@sm:sui-block': condition });

// Deprecated: Use showDesktopLayout instead
export const showAboveSmBreakpoint = showDesktopLayout;

// Deprecated: Use showMobileLayout instead
export const showBelowSmBreakpoint = showMobileLayout;

// Deprecated: Use showDesktopLayoutIf instead
export const showAboveSmBreakpointIf = showDesktopLayoutIf;

// Adding a custom class to a card overwrites the default classes
export const defaultCardContentProps = classNames(
  'sui-flex',
  'sui-overflow-hidden',
  'sui-p-4',
  'sui-gap-4',
  'sui-flex-col'
);

/*
Class names for DesktopCarousel container.

Note: do not pin `.swiper` to the container height. The SUI Carousel lays its scrollbar out as a
wrapped flex line underneath the cards, and this container gets `overflow: hidden` applied to it by
the Carousel itself (it matches `containerId`). A full-height `.swiper` leaves the cards row filling
the container, which pushes the scrollbar past the bottom edge where it gets clipped away entirely -
that was WOR2-973. Letting `.swiper` size to its content keeps the scrollbar inside the clipped box,
matching the Lists and Quotes carousels.
*/
export const desktopCarouselContainerClass = classNames(
  '[&_.swiper-slide]:sui-w-auto',
  'sui-h-full',
  '[&>div]:sui-h-full',
  '[&_.swiper-wrapper]:!sui-h-full'
);
